import './less/spinner.less';

class Spinner {
	
	constructor() {
		this.classes = {
			'main': 'spinner' // main spinner element class
		};
	}
	
	buildSpinner = (parent, color, icon = '<i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>') => {
		let container = document.createElement('div');
		container.className = this.classes.main;
		container.style.backgroundColor = color;
		
		let iconContainer = document.createElement('div');
		iconContainer.className = 'spinner__icon';
		
		container.appendChild(iconContainer);
		iconContainer.innerHTML = icon;
		
		parent.appendChild(container);
	};
	
	show = (parent, color) => {
		this.buildSpinner(parent, color);
	}
	
	remove = () => {
		$('.spinner').addClass('faded');
		setTimeout(() => {
			$('.spinner').remove();
		}, 1000);
		
	}
	
}

const spinner = new Spinner();

export {spinner};


// WEBPACK FOOTER //
// ../components/UI/spinner/spinner.js